

























import { Vue } from "vue-property-decorator";

import Info from "@/views/invest/form/stadium_info.vue"
import Cooperation from "./cooperation.vue"
import Business from "./business.vue"
import ManageLogs from "./manage_logs.vue"

export default Vue.extend({
  name: "StadiumEstimate",
  components: { Info, Cooperation, Business, ManageLogs },
  data() {
    return {
      id    : "",
      active: 1,
    }
  },
  methods: {
    /* 提交审核 */
    async submit(op: number) {
      const params = { estimate_id: this.id, op }
      const res = await this.$store.dispatch("invest/submit", params);
      if (res.Code == 200) {
        this.$success({
          content: res.Message,
        })
      } else {
        this.$error({
          content: res.Message,
        })
      }
    }
  },
  mounted() {
    const query = { ...this.$route.query };
    if (query.id != "") {
      this.id = query.id as string;
    }
  }
})

